/**
 * Account types
 */

export type AccountType = 'brokerage' | 'physical' | 'fixed_income'

export interface Account {
  account_id: string
  name: string
  type: AccountType
  institution?: string | null
  notes?: string | null
  created_at: string
  updated_at: string
  // Computed fields
  total_value?: number | null
  holdings_count: number
}

export interface AccountCreate {
  account_id: string
  name: string
  type: AccountType
  institution?: string | null
  notes?: string | null
}

export interface AccountUpdate {
  name?: string
  institution?: string | null
  notes?: string | null
}

export const ACCOUNT_TYPE_LABELS: Record<AccountType, string> = {
  brokerage: 'Brokerage',
  physical: 'Physical Assets',
  fixed_income: 'Fixed Income',
}
